import _ from 'lodash';
import { authRoutes } from '@/router/routes';
import {
    INIT_SIDE_MENU
} from '../mutationTypes';

const sideMenuGroups = [
    {
        name: 'home',
        title: '首页',
        id: ''
    },
    {
        name: 'open',
        title: '收银开单',
        id: ''
    },
    {
        name: 'card',
        title: '营销业务',
        id: '2'
    },
    {
        name: 'service',
        title: '服务管理',
        id: '151'
    },
    {
        name: 'client',
        title: '客户管理',
        id: '3'
    },
    {
        name: 'store',
        title: '库存管理',
        id: '78'
    },
    {
        name: 'list',
        title: '收益管理',
        id: '4'
    },
    {
        name: 'member',
        title: '员工管理',
        id: '5'
    },
    {
        name: 'auth',
        title: '设置',
        id: '6'
    }
];

const state = {
    data: []
};

const mutations = {
    [INIT_SIDE_MENU](state, authRoutes) {
        const routesByGroup = _.groupBy(authRoutes, _.property('group'));
        const pickItemProps = item => ({
            path: item.path,
            name: item.meta.title,
            id: item.meta.pageId
        });
        const screenTargetList = targetList => _.map(targetList, pickItemProps);

        const extendsGroupWithList = (group, list) => Object.assign({}, group, {
            list: screenTargetList(list),
        });

        const mergeSideMenuWithRoutes = (sideMenuGroups, routesByGroup) =>
            _.map(sideMenuGroups, (group) => {
                const targetList = routesByGroup[group.name];
                return extendsGroupWithList(group, targetList);
            });


        state.data = mergeSideMenuWithRoutes(sideMenuGroups, routesByGroup);
    },
};

// actions
export const actions = {
    initSideMenu({ commit }) {
        commit(INIT_SIDE_MENU, authRoutes);
    },
};

// getters
const getSideMenu = state => state.sideMenu.data;

export const getters = {
    getSideMenu
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/sideMenu.js